import { useEffect, useState, memo } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faHeart,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import NavbarLogo from "./csdv2Logo.png";
import { GlobalData } from "../../assets/data/GlodalData";

const NAVIGATION = [
  { name: "Our Mission", path: "/our-mission" },
  { name: "Our Stories", path: "/our-stories" },
  { name: "Our Kids", path: "/our-kids" },
  { name: "Education & CME", path: "/education-cme" },
  { name: "About Us", path: "/aboutus" },
  { name: "Contact", path: "/contactus" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [mobileMenuOpen]);

  return (
    <nav
      className={`fixed w-full z-[100] transition-all duration-500 ${mobileMenuOpen
        ? "py-4 bg-slate-900"
        : scrolled
          ? " bg-white/80 backdrop-blur-lg shadow-lg"
          : " bg-transparent"
        }`}
    >
      <div className="bg-white text-[14px] text-center font-bold uppercase">Reaching the Unreached</div>
      <div className="container mx-auto px-2 md:px-2 flex items-center justify-between relative z-[110]">

        {/* Mobile Toggle - Left Side */}
        <div className="md:hidden flex-1 flex justify-start">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`p-2 rounded-lg transition-colors ${mobileMenuOpen || !scrolled ? "text-white hover:bg-white/10" : "text-slate-900 hover:bg-slate-100"
              }`}
          >
            <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} size="lg" />
          </button>
        </div>

        {/* Logo - Center on Mobile, Left on Desktop */}
        <div className="flex-[2] md:flex-initial flex items-center justify-center md:justify-start">
          <Link to="/" className="flex items-center gap-2 group">

            {/* Logo */}
            <div className="flex-shrink-0 transition-transform duration-200 group-hover:scale-105">
              <img
                src={NavbarLogo}
                alt="Logo"
                className="h-[55px] md:h-[70px] w-auto object-contain"
              />
            </div>

            {/* Text Content */}
            <div
              className={`flex flex-col leading-tight ${mobileMenuOpen || !scrolled ? "text-white" : "text-slate-900"
                }`}
            >
              {/* Title */}
              <span className="font-extrabold text-lg md:text-xl tracking-tight">
                SHISHU HRIDAY
              </span>

              {/* Subtitle */}
              <span
                className={`text-xs font-medium ${mobileMenuOpen || !scrolled ? "text-gray-200" : "text-slate-500"
                  }`}
              >
                Reaching the unreached
              </span>
            </div>

          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8 mx-auto">
          {NAVIGATION.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`text-[12px] font-bold uppercase tracking-widest transition-all hover:text-brand-red ${scrolled && !mobileMenuOpen ? "text-slate-700" : "text-white drop-shadow-md"
                } ${location.pathname === item.path ? "text-brand-red" : ""}`}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* Actions - Right Side */}
        <div className="flex-1 md:flex-initial flex items-center justify-end gap-4 text-nowrap">
          <div className="hidden lg:flex items-center gap-3 mr-4">
            {[faFacebookF, faInstagram, faTwitter].map((icon, i) => (
              <a key={i} href="#" className={`w-8 h-8 flex items-center justify-center rounded-full transition-all hover:bg-brand-red hover:text-white ${scrolled && !mobileMenuOpen ? 'text-slate-400 bg-slate-100' : 'text-white bg-white/10'
                }`}>
                <FontAwesomeIcon icon={icon} size="xs" />
              </a>
            ))}
          </div>

          <Link
            to="/donate-now"
            className="px-4 md:px-6 py-2 md:py-2.5 gradient-bg text-white rounded-full font-black text-[10px] md:text-sm hover-scale hover-glow shadow-lg flex items-center gap-1.5 md:gap-2"
          >
            DONATE <FontAwesomeIcon icon={faHeart} className="animate-pulse hidden sm:inline" />
          </Link>
        </div>
      </div >

      {/* Mobile Menu Overlay */}
      < div
        className={`fixed inset-0 bg-slate-900 backdrop-blur-xl z-[100] flex flex-col items-center justify-center transition-all duration-500 ${mobileMenuOpen ? "translate-y-0 opacity-100 visible" : "-translate-y-full opacity-0 invisible"
          }`}
      >
        <div className="flex flex-col items-center gap-8 mt-20">
          {NAVIGATION.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="text-2xl font-black text-white hover:text-brand-red transition-colors uppercase tracking-tighter"
            >
              {item.name}
            </Link>
          ))}
          <Link
            to="/donate-now"
            className="mt-8 px-12 py-4 gradient-bg text-white rounded-full font-black text-2xl shadow-2xl"
          >
            DONATE NOW
          </Link>
        </div>
      </div >
    </nav >
  );
};

export default Navbar;
